import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  HEALTH_SCREENING_DETAILS_PATH,
  HEALTH_SCREENING_HISTORY_PATH,
  HEALTH_SCREENING_PATH,
  HEALTH_SCREENING_RESULTS_INDICATOR_PATH,
  HEALTH_SCREENING_RESULTS_PATH,
  HEALTH_SCREENING_SCREENING_TYPE_SUMMARY_PATH,
  HEALTH_SCREENING_SUMMARY_PATH,
  HEALTH_SCREENING_UNDERSTAND_MY_READINGS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const HealthScreeningSummaryPage = lazy(() => import('./pages/HealthScreeningSummaryPage/HealthScreeningSummaryPage'));

const HealthScreeningTypeSummaryPage = lazy(
  () => import('./pages/HealthScreeningTypeSummaryPage/HealthScreeningTypeSummaryPage')
);

const HealthScreeningDetailsPage = lazy(() => import('./pages/HealthScreeningDetailsPage/HealthScreeningDetailsPage'));

const HealthScreeningUnderstandingMyReadingsPage = lazy(
  () => import('./pages/HealthScreeningUnderstandingMyReadingsPage/HealthScreeningUnderstandingMyReadingsPage')
);

const HealthScreeningResultsPage = lazy(() => import('./pages/HealthScreeningResultsPage/HealthScreeningResultsPage'));

const HealthScreeningLandingPage = lazy(() => import('./pages/HealthScreeningLandingPage'));

const HealthScreeningIndicatorPage = lazy(() => import('./pages/HealthScreeningIndicatorPage'));

const HealthScreeningHistoryPage = lazy(() => import('./pages/HealthScreeningHistoryPage'));

export const HEALTH_SCREENING_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningSummaryPage />,
    displayTitle: () => 'Health Screening',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningTypeSummaryPage />,
    displayTitle: () => 'Health Screening',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_SCREENING_TYPE_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningDetailsPage />,
    displayTitle: () => 'Screening Details',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningUnderstandingMyReadingsPage />,
    displayTitle: () => 'Understand my readings',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_UNDERSTAND_MY_READINGS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningResultsPage />,
    displayTitle: () => 'Screening Results',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningLandingPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningIndicatorPage />,
    displayTitle: () => 'Screening Results indicators',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_RESULTS_INDICATOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningHistoryPage />,
    displayTitle: () => 'Screening History',
    pageType: PageType.PRIVATE,
    path: HEALTH_SCREENING_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthScreening,
  },
];
